import APIEntry from "@/api/APIEntry.js";
import { CONFIG } from "@/datas/configs.js";
import axios from "axios";
import store from "../store";

/**
 * Global mapping interfaces
 */
export default Object.freeze({
  /**
   * api entry 매칭 시키기
   */
  entry: function() {
    if (!arguments.length) {
      return null;
    }
    let args = [];
    Array.prototype.push.apply(args, arguments);

    // let $store = args.shift();

    let match = store.state.entries[args[0]];

    if (typeof match === undefined) {
      return null;
    }
    args.shift();

    let mallId = store.state.mallId;
    let appCode = store.state.appCode;
    let mallType = store.state.mallType;

    if ((!mallId || !appCode) && mallType == null) {
      return null;
    }

    args.unshift(mallId);
    args.unshift(appCode);

    let uri = match.path;
    args.map((item, index) => {
      let search = `{${index}}`;
      uri = uri.replace(search, item);
    });
    return new APIEntry(uri, match.method);
  },
  /**
   * api request
   * @param {APIEntry} entry API URI 맵핑 객체
   * @param {Object} payload 요청 본문 파라미터
   */
  api: async function(entry, payload) {
    if (entry === null) {
      throw new Error("'entry' parameter is required.");
    }
    // status code 확인 하여 토큰 갱신 처리
    axios.defaults.headers.common["Content-Type"] = "application/json";
    axios.interceptors.response.use(null, async (error) => {
      // LOGIN 액션 실행 ( CAFE24 )
      if (store.state.mallType == null) {
        if (error.config && error.response && error.response.status === 401) {
          await store.dispatch("REFRESH_ACCESS_TOKEN", store);
          error.config.headers.Authorization = store.state.accessToken;
          return axios.request(error.config);
        }
      }

      // LOGIN 액션 실행 ( SHOPLUS )
      if (store.state.mallType == "shoplus" && error.config) {
        if (error.response.status === 401) {
          await store.dispatch(
            "SET_SHOPLUE_ACCESS_REFRESH_TOKEN",
            store.state.refreshToken
          );
          error.config.headers.Authorization = store.state.accessToken;
          return axios.request(error.config);
        }
        if (error.response.status === 404) {
          sessionStorage.clear();
          localStorage.clear();
          location.href = "/shoplus_service";
        }
      }

      return Promise.reject(error);
    });

    let statement = {
      baseURL: CONFIG.API_HOST,
      url: entry.getPath(),
      method: entry.getMethod(),
    };

    if (payload) {
      if (["POST", "DELETE", "PUT"].includes(entry.getMethod())) {
        statement.data = payload;
      } else {
        statement.params = payload;
      }
    }

    let res = await axios(statement);
    return res.data;
  },
  /**
   * date 포멧
   * @param {new Date} date
   */
  yyyymmdd: function(date) {
    let yyyy = date.getFullYear().toString();
    let mm = (date.getMonth() + 1).toString();
    let dd = date.getDate().toString();
    return (
      yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0])
    );
  },
  /**
   * 숫자만 입력 체크
   */
  checkNumber: function(e) {
    if (
      e.keyCode == 69 ||
      e.keyCode == 190 ||
      e.keyCode == 109 ||
      e.keyCode == 189
    ) {
      e.preventDefault();
      return false;
    }
  },
  replaceNumber: function(e, max, chkNumber = false) {
    let val = e.target.value;
    let replaceVal = val.replace(/[^0-9]/g, "").substr(0, max - 1);
    e.target.value = chkNumber === true ? Number(replaceVal) : replaceVal;
    if (chkNumber === true && e.target.value == 0) {
      e.target.value = "";
    }
    var event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    e.target.dispatchEvent(event);
  },
  replaceMaxNumber: function(e, max, chkNumber = false) {
    let val = e.target.value;
    let replaceVal = val.replace(/[^0-9]/g, "").substr(0, max - 1);
    e.target.value = chkNumber === true ? Number(replaceVal) : replaceVal;
    if (chkNumber === true && e.target.value == 0) {
      e.target.value = "";
    }
    if (replaceVal > 10000) {
      e.target.value = 10000;
    }
    var event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    e.target.dispatchEvent(event);
  },
  replaceDateCount: function(e, type) {
    let val = e.target.value;
    let max = type === "y" || type === "m" ? 2 : 3;
    let replaceVal = val.replace(/[^0-9]/g, "").substr(0, max);
    e.target.value = Number(replaceVal);
    if (e.target.value == 0) {
      e.target.value = "";
    }
    var event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    e.target.dispatchEvent(event);
  },
  urlPath: function() {
    let pathArray = window.location.pathname.split("/");
    return pathArray[1];
  },
  isPhoneNumber: function(phone_number) {
    let regExp = /^(01[016789]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
    let result = regExp.test(phone_number);
    return result;
  },
  isMail: function(mail) {
    let regExp = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
    let result = regExp.test(mail);
    return result;
  },
});
